import { forwardRef, type ReactNode } from 'react';

import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';

//#region Typings
/**
 * Accepted properties for the TitleBar Prefix
 * @public
 */
export interface TitleBarPrefixProps extends StylingProps, DataTestId {
  /** Elements to be displayed in the TitleBar Prefix slot. */
  children: ReactNode;
}
//#endregion

/**
 * TitleBar Prefix component
 * @public
 */
export const Prefix = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  TitleBarPrefixProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  }: TitleBarPrefixProps = props;

  return (
    <div
      ref={forwardedRef}
      className={consumerClassName}
      style={consumerStyle}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
});
